import { ApolloClient, InMemoryCache } from '@apollo/client';
import { environment } from '@bakerweb/client-environment';

export const gqlPublic = new ApolloClient({
  uri: environment.graphQLUrl,
  cache: new InMemoryCache()
});
